import { render, staticRenderFns } from "./EditBoxListDialog.vue?vue&type=template&id=00bd2726&scoped=true&"
import script from "./EditBoxListDialog.vue?vue&type=script&lang=js&"
export * from "./EditBoxListDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00bd2726",
  null
  
)

export default component.exports